import { DAYS } from './constants';
import { TIME_OPTIONS } from './timeOptions';

// Turn a daySchedule object like { mon: '19:00', thu: '20:00' } into the
// human-readable string the SealStep pill displays. Days are emitted in
// week order (mon→sun) so the order is stable regardless of insertion
// order. Times use the 12-hour AM/PM label from TIME_OPTIONS.
// Ported from prototypes/campaign-creation-prototype.jsx scheduleSummary
// inline expression (lines 2331-2341).
export const formatSchedule = (daySchedule, scheduleTBD) => {
  if (scheduleTBD) return 'TBD';
  const map = daySchedule || {};
  if (Object.keys(map).length === 0) return 'not set';
  return DAYS
    .filter((d) => map[d.key] != null)
    .map((d) => {
      const time = map[d.key];
      const opt = TIME_OPTIONS.find((o) => o.value === time);
      return `${d.full.slice(0, 3)} ${opt ? opt.label : time}`;
    })
    .join(' · ');
};
